<template>
	<div v-if="data" :class="['sub-values', {'inline': !data.necessary}]">
		<div v-if="!data.necessary" class="sub-value">
			<div class="label">Nein</div>
		</div>
		<template v-else>
			<div class="sub-value clickable" @click="$emit('click')">
				<div class="label">Länder</div>
				<div>
					<LabelList
						:characteristics="getCharacteristics(data.geo)"
						empty-text="Weltweit"
						:label-type="labelTypeJobProfile"
					/>
				</div>
			</div>
			<div class="sub-value clickable" @click="$emit('click')">
				<div class="label">Umfang</div>
				<div>
					<LabelList
						:characteristics="getCharacteristics(data.scope)"
						:label-type="labelTypeJobProfile"
					/>
				</div>
			</div>
			<div class="sub-value clickable" @click="$emit('click')">
				<div class="label">Externe Übernachtungen</div>
				<div>
					<LabelList
						:characteristics="getCharacteristics(data.externalSleepover)"
						:label-type="labelTypeJobProfile"
						empty-text="Keine notwendig"
					/>
				</div>
			</div>
		</template>
	</div>
</template>

<script>
import SelectedItems from "@/vue/characteristic/SelectedItems.vue";
import {mapState} from "vuex";
import LabelList from "@/vue/characteristic/LabelList.vue";
import Label from "@/vue/characteristic/Label.vue";
import {JOB_PROFILE} from "@/helper/characteristic/Label";

export default {
	components: {Label, LabelList, SelectedItems},
	props: {
		data: {
			type: Object,
			required: false
		}
	},

	computed: {
		...mapState('meta', ['meta']),
		labelTypeJobProfile ()
		{
			return JOB_PROFILE;
		}
	},

	methods: {
		getCharacteristics (items)
		{
			return _.map(items, 'item');
		}
	}
}
</script>
